// React side of the automatic zoom (lib/displayZoom.js).
//
//   useDisplayZoom()          the zoom JS sizes should use (0.70-2.00; 1 in
//                             pop-outs and while printing).  For the few px
//                             sizes CSS can't reach: Recharts props, px-wide
//                             popups.  Everything in rem follows on its own.
//   useDisplayZoomState()     { zoom, target, pageZoom, size, popup, … } for
//                             Profile's Display size control.
//   useChartSizing()          Recharts sizes at this zoom: font (floored at
//                             9 px), axis width / height, chart height.
// (useDisplayZoomRouteSync, App.js's re-check when the path crosses
// /popup/*, is its own file so components here never pull in the router.)
import { useMemo, useSyncExternalStore } from 'react'
import {
  getDisplayZoom, getDisplayZoomState, subscribeDisplayZoom, zoomPx, zoomFontPx,
} from '../lib/displayZoom'

const serverZoom = () => 1

export default function useDisplayZoom () {
  return useSyncExternalStore(subscribeDisplayZoom, getDisplayZoom, serverZoom)
}

export function useDisplayZoomState () {
  return useSyncExternalStore(subscribeDisplayZoom, getDisplayZoomState, getDisplayZoomState)
}

// Recharts defaults scaled together with their text, so a 2.0 zoom doesn't
// put 24 px ticks in the 60 px axis Recharts reserves at 12 px.
export function useChartSizing () {
  const zoom = useDisplayZoom()
  return useMemo(() => ({
    zoom,
    font: zoomFontPx(12, zoom),
    yAxisWidth: zoomPx(60, zoom),
    xAxisHeight: zoomPx(30, zoom),
    height: (px) => zoomPx(px, zoom),
  }), [zoom])
}
